import { SET_FUTURE_ORDERS, SET_NEXT_ORDER_DATES, SET_ORDER_DETAILS, SET_ORDER_STATUS_DATA, SET_PREVIOUS_CADENCE, UPDATE_NEXT_BILL_DATE, UPDATE_NEXT_CADENCE, } from "../actions/types";
const initState = {
    orderStatusData: {
        items: [],
        order_date: "",
        status: "",
        tracking_url: "",
    },
    orderDetails: {
        expected_delivery: "",
        items: [],
        order_date: "",
        order_id: "",
        status: "",
        tracking_url: "",
        total_price: "",
        expectedDeliveryDate: "",
        loaded_points: 0,
        shipping_cost: 0,
        tax: 0,
        discount: 0,
        subtotal: 0,
        duty: 0,
    },
    nextOrderDates: {
        deliverydate1: "",
        deliverydate2: "",
        hasSubscription: true,
        nextBillDate: "",
        nextShipmentDay: 0,
        nextShipmentMonth: 0,
        nextShipmentYear: 0,
        plan: null,
        planCadence: 0,
        previousCadence: 0,
        planCadenceType: "",
        showCadenceFlexibility: false,
        eligibleAdvantage: false,
        needsToProvidePauseReason: false,
        nextOrderSkipped: false
    },
    futureOrders: [],
};
export default function ordersInfoReducer(state = initState, action) {
    switch (action.type) {
        case SET_ORDER_DETAILS: {
            return {
                ...state,
                orderDetails: action.payload,
            };
        }
        case SET_NEXT_ORDER_DATES: {
            return {
                ...state,
                nextOrderDates: action.payload,
            };
        }
        case SET_ORDER_STATUS_DATA: {
            return {
                ...state,
                orderStatusData: action.payload,
            };
        }
        case UPDATE_NEXT_CADENCE: {
            const { plan, planCadence, planCadenceType } = action.payload;
            return {
                ...state,
                nextOrderDates: {
                    ...state.nextOrderDates,
                    plan,
                    planCadence,
                    planCadenceType,
                    // showCadenceFlexibility: action.payload.showCadenceFlexibility,
                },
            };
        }
        case UPDATE_NEXT_BILL_DATE: {
            return {
                ...state,
                nextOrderDates: {
                    ...state.nextOrderDates,
                    nextBillDate: action.payload,
                },
            };
        }
        case SET_PREVIOUS_CADENCE: {
            return {
                ...state,
                nextOrderDates: {
                    ...state.nextOrderDates,
                    previousCadence: action.payload,
                },
            };
        }
        case SET_FUTURE_ORDERS: {
            return {
                ...state,
                futureOrders: action.payload,
            };
        }
        default:
            return state;
    }
}
